import request from '@/utils/request'

// 공사 계약승인 조회
export function getContractApprovalManage(params, isNotify) {
  return request({
    url: `/api/getContractApprovalManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}
// 공사 계약승인 (승인, 거절, 관리자 코멘트) 
export function saveContractApprovalStatus(params, isNotify) {
  return request({
    url: `/api/saveContractApprovalStatus`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 공사 계약승인 저장
export function saveContractApprovalManage(params, isNotify) {
  return request({
    url: `/api/saveContractApprovalManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 공사 계약승인 상세페이지 조회
export function getContractApprovalManageDetail(params, isNotify) {
  return request({
    url: `/api/getContractApprovalManageDetail`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'searched' }
  })
}

// 공사 결제승인 저장
export function savePaymentApprovalManage (params, isNotify) {
  return request({
    url: `/api/savePaymentApprovalManage`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}
// 사용종료일 연장/취소
export function updateExtendInfo (params, isNotify) {
  return request({
    url: `/api/updateExtendInfo`,
    method: 'POST',
    data: params,
    meta: { apiVersion: '1.0.0' },
    headers: { 'Content-Type': 'application/json' },
    Notify: { use: isNotify, apitype: 'saved' }
  })
}